import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ErrorMessages } from '../../shared/error/error-messages';
import { Logger } from '../../shared/logger';
import { ArchivoAnuncio } from '../models';
import { RestService } from './rest.service';

@Injectable()
export class ArchivoAnuncioService extends RestService<ArchivoAnuncio> {

    constructor(
        protected errorMessages: ErrorMessages,
        protected afAuth: AngularFireAuth,
        protected store: AngularFirestore,
        protected logger: Logger
    ) {
        super(errorMessages, afAuth, store, logger, 'archivos-anuncios');
    }

}
